@if ((corporateTaxEntity$ | async)) {
  <form [formGroup]="investeringenBijzonderhedenFg">
    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="desinvesteringsbijtelling" id="desinvesteringsbijtelling"
                                      label="Desinvesteringsbijtelling"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="investeringsaftrekUitVoorgaandeJaren" id="investeringsaftrekUitVoorgaandeJaren"
                                      label="Restant KIA"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="kiaCaribischDeelVanNederland" id="kiaCaribischDeelVanNederland"
                                      label="KIA Caribisch gebied"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="rdaAftrek" id="rdaAftrek"
                                      label="RDA aftrek"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
  </form>
}

